/**
 * This is the beginning of what should become a much more complete set of colors, but rebrand color palette is yet
 * to be finalized.
 */
const brand = {
  luckyBreak: '#FF6552',
  tenThousandCoffees: '#1F1511',
  cardWhite: '#FFFCF8',
  goldenMomentBase: '#FFE7B0',
  goldenMomentDark: '#746844',
} as const;

/**
 * Warm-toned greyscale used on the individual onboarding rebrand. Replaces
 * the cool blue-grey of legacy `palette.neutral` on the customize-card,
 * signup, get-blinq, and onboarding-nav-footer surfaces. Numeric scale
 * matches `palette-next` (50 lightest → 900 darkest) for forward
 * compatibility.
 */
const neutral = {
  0: '#FFFFFF',
  50: '#FFFDFA',
  100: '#FAF6ED',
  200: '#E8E8E8',
  300: '#DADADA',
  400: '#BEBEBE',
  500: '#8A8A8A',
  700: '#554D48',
  800: '#4D4D4D',
  900: '#120808',
} as const;

const content = {
  primary: '#120808',
  secondary: '#4D4D4D',
  tertiary: '#8A8A8A',
  inversePrimary: '#FFFFFF',
  inverseSecondary: '#DADADA',
} as const;

const border = {
  primary: '#DADADA',
  secondary: '#E8E8E8',
} as const;

const background = {
  primary: '#FFFFFF',
  surface: '#FFFDFA',
} as const;

export const paletteRebrand = {
  brand,
  neutral,
  content,
  border,
  background,
} as const;
